import { tv } from 'tailwind-variants'

export const radioCard = tv({
  slots: {
    container: 'group relative flex cursor-pointer flex-col hover:opacity-70 active:opacity-70',
    card: 'flex flex-grow flex-row items-center gap-x-4 rounded-lg border border-grey-300 p-4',
    iconContainer: 'group-hover:opacity-70',
    textContainer:
      'flex shrink grow flex-col justify-between gap-y-1 group-hover:opacity-70 web:flex-1',
    titleContainer: 'flex flex-row justify-between gap-x-4',
    tag: 'h-5 w-full bg-grey-300 text-black/70',
  },
  variants: {
    layout: {
      wide: {},
      compact: {
        container: 'flex-1',
        card: [
          'ios:gap-x-0 ios:flex-none ios:flex-grow android:flex-none android:gap-x-0 ios:flex-col ios:gap-y-2.5 android:gap-y-2.5 ios:px-2.5 ios:py-4 android:flex-col android:px-2.5 android:py-4',
          'sm:flex-col sm:gap-x-0 sm:gap-y-2.5 sm:px-2.5 sm:py-4',
        ],
        textContainer: 'sm:items-center',
        titleContainer: [
          'ios:gap-x-0 android:gap-x-0 ios:gap-y-1 ios:space-between android:space-between android:gap-y-1 ios:flex-col android:flex-col',
          'sm:flex-col sm:justify-start sm:gap-x-0 sm:gap-y-1',
        ],
      },
    },
    hasBottomTag: {
      true: {
        card: 'rounded-b-none',
      },
    },
    hasTopTag: {
      true: {
        card: 'rounded-t-none',
      },
    },
    variant: {
      card: {},
      chip: {
        container: 'web:flex-1',
        card: 'h-[69px] gap-x-2.5 rounded-md border-0 bg-grey-100 px-5 py-0',
      },
    },
    hasTopTags: {
      true: {},
    },
    hasBottomTags: {
      true: {},
    },
    isUntouched: {
      true: {
        tag: 'bg-grey-100',
      },
    },
    hasImage: {
      true: {
        card: 'bg-grey-100',
        iconContainer: 'hidden',
      },
    },
    isSelected: {
      true: {
        card: 'border-2 border-deep-forest',
        tag: 'bg-deep-forest text-white',
      },
    },
    disabled: {
      true: {
        card: 'cursor-default opacity-40',
        iconContainer: 'opacity-40',
        tag: 'opacity-40',
      },
    },
  },
  compoundVariants: [
    {
      isSelected: true,
      layout: 'wide',
      className: {
        card: ['p-3.5'],
      },
    },
    {
      isSelected: true,
      layout: 'compact',
      className: {
        card: 'px-2 py-3.5',
      },
    },
    {
      hasTopTag: false,
      hasTopTags: true,
      layout: 'compact',
      className: {
        container: 'pt-5',
      },
    },
    {
      hasBottomTag: false,
      hasBottomTags: true,
      layout: 'compact',
      className: {
        container: 'pb-5',
      },
    },
    {
      variant: 'chip',
      isSelected: true,
      className: {
        card: 'border-0 bg-black px-5 py-0',
      },
    },
  ],
})

export const radioCardImage = tv({
  base: 'h-[42px] w-[42px] shrink-0 overflow-hidden rounded-full border-[3px] border-white group-hover:opacity-70',
})
